module.exports = __webpack_public_path__ + "static/media/djisdk.28118a0a.avif";